var iconButtonSmallSize = 24;
var PROGRESS_BUTTON_STROKE_WIDTH = 2;
var DEFAULT_SETTINGS = {
    width: iconButtonSmallSize,
    height: iconButtonSmallSize,
    startPos: (iconButtonSmallSize - PROGRESS_BUTTON_STROKE_WIDTH) / 2,
    strokeWidth: PROGRESS_BUTTON_STROKE_WIDTH,
    borderRadius: 12
};

export { DEFAULT_SETTINGS, PROGRESS_BUTTON_STROKE_WIDTH };
